import { AdUVPPlus } from '@/components/common/Ad'
import { ArticlePreview } from '@/components/common/ArticlePreview'
import { useAds } from '@/components/providers/AdsProvider'
import { usePage } from '@/components/providers/PageProvider'

import styles from './FeaturedCommonArticles.module.scss'

export const FeaturedCommonArticles = () => {
  const { page } = usePage()
  const { uvpPlusDisabled } = useAds()

  const articlePreviews = page?.articlePreviews?.slice(0, 2)

  if (!articlePreviews?.length && uvpPlusDisabled) return null

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {articlePreviews?.map((article) => (
          <li key={article.slug}>
            <ArticlePreview article={article} hideExcerpt newTab showBg />
          </li>
        ))}
        {!uvpPlusDisabled && (
          <li className={styles.ad}>
            <AdUVPPlus />
          </li>
        )}
      </ul>
    </div>
  )
}
